import request from '@services/request';

import { formatDateISO, todayISO } from '@shared/utils/dateUtils';

const getCorrespondentRequests = async (search = {}, page = 1, size = 3) => {
  const params = {
    st: search.code || 0,
    dt: (search.date_to && formatDateISO(search.date_to)) || todayISO(),
    offset: page,
    limit: size,
    df: (search.date_from && formatDateISO(search.date_from)) || todayISO(),
  };
  const result = await request.get('/api/v1/corresponsal/correspondents/requests', params);
  const { data } = result;
  return data;
};

const putCorrespondentRequest = async (idRequest, params) => {

  const body = { data: { ...params } };
  const result = await request.put(`/api/v1/corresponsal/correspondents/request/${idRequest}`, body);
  const { data } = result;
  return data;
};

const getCorrespondentRequestsHistory = async (idRequest) => {
  const result = await request.get(`/api/v1/corresponsal/correspondents-history/requests/${idRequest}`);
  const { data } = result;
  return data;
};

export { getCorrespondentRequests, getCorrespondentRequestsHistory, putCorrespondentRequest };

